import VIPRouter from './vip'
export default [
    {
        path: '/',
        name: '首页',
        component: () => import(/* webpackChunkName: "home" */ '../views/Index.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
    },
    {
        path: '/register',
        name: '注册',
        component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue')
    },
    {
        path: '/findpwd',
        name: '找回密码',
        component: () => import(/* webpackChunkName: "findpwd" */ '../views/FindPWD.vue')
    },
    {
        path: '/list',
        name: '产品列表',
        component: () => import(/* webpackChunkName: "list" */ '../views/List.vue'),
        meta: {
            keepAlive: true,
            isBack: false
        }
    },
    {
        path: '/coupongoodlist',
        name: '优惠券产品列表',
        component: () => import(/* webpackChunkName: "coupongoodlist" */ '../views/CouponGoodList.vue'),
        meta: {
            keepAlive: true,
            isBack: false
        }
    },
    {
        path: '/info',
        name: '产品详情',
        component: () => import(/* webpackChunkName: "info" */ '../views/Info.vue')
    },
    {
        path: '/cart',
        name: '购物车',
        component: () => import(/* webpackChunkName: "cart" */ '../views/Cart.vue')
    },
    {
        path: '/menu',
        name: '菜单',
        component: () => import(/* webpackChunkName: "menu" */ '../views/Menuc.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/order',
        name: '确认订单',
        component: () => import(/* webpackChunkName: "order" */ '../views/Order.vue')
    },
    {
        path: '/orderpay',
        name: '订单支付',
        component: () => import(/* webpackChunkName: "orderpay" */ '../views/OrderPay.vue')
    },
    {
        path: '/payothers',
        name: 'PayOthers',
        component: () => import(/* webpackChunkName: "orderpay" */ '../views/PayOthers.vue')
    },
    {
        path: '/payresult',
        name: '支付结果',
        component: () => import(/* webpackChunkName: "payresult" */ '../views/PayResult.vue')
    },
    {
        path: '/orderlist',
        name: '订单列表',
        component: () => import(/* webpackChunkName: "orderlist" */ '../views/OrderList.vue')
    },
    {
        path: '/orderdetail',
        name: '订单详情',
        component: () => import(/* webpackChunkName: "orderdetail" */ '../views/OrderDetail.vue')
    },
    {
        path: '/mycenter',
        name: '个人中心',
        component: () => import(/* webpackChunkName: "mycenter" */ '../views/MyCenter.vue')
    },
    {
        path: '/myset',
        name: '个人设置',
        component: () => import(/* webpackChunkName: "myset" */ '../views/MySet.vue')
    },
    {
        path: '/myinfo',
        name: '我的信息',
        component: () => import(/* webpackChunkName: "myinfo" */ '../views/MyInfo.vue')
    },
    {
        path: '/mysafe',
        name: '账户安全',
        component: () => import(/* webpackChunkName: "mysafe" */ '../views/MySafe.vue')
    },
    {
        path: '/editpass',
        name: '修改密码',
        component: () => import(/* webpackChunkName: "editpass" */ '../views/ChangePassword.vue')
    },
    {
        path: '/myaddr',
        name: '收货地址管理',
        component: () => import(/* webpackChunkName: "myaddr" */ '../views/AddrList.vue')
    },
    {
        path: '/editaddr',
        name: '收货地址编辑',
        component: () => import(/* webpackChunkName: "editaddr" */ '../views/AddrEdit.vue')
    },
    {
        path: '/conpon',
        name: '优惠券',
        component: () => import(/* webpackChunkName: "conpon" */ '../views/ConponList.vue')
    },
    {
        path: '/giftcard',
        name: '礼品卡',
        component: () => import(/* webpackChunkName: "giftcard" */ '../views/Balance.vue')
    },
    {
        path: '/brecord',
        name: '礼品卡消费记录',
        component: () => import(/* webpackChunkName: "brecord" */ '../views/BalanceRecords.vue')
    },
    {
        path: '/returnexchange',
        name: '申请退换货',
        component: () => import(/* webpackChunkName: "returnexchange" */ '../views/ApplyReturnOrder.vue')
    },
    {
        path: '/shop',
        name: '实体店',
        component: () => import(/* webpackChunkName: "shop" */ '../views/Shop.vue')
    },
    {
        path: '/blesslist',
        name: '祝福语列表',
        component: () => import(/* webpackChunkName: "blesslist" */ '../views/BlessList.vue')
    },
    {
        path: '/vip',
        children: VIPRouter,
        component: () => import(/* webpackChunkName: "vipmain" */ '../views/VIPMain.vue')
    },
    {
        path: '/payofanother',
        name: 'payofanother',
        component: () => import(/* webpackChunkName: "vipmain" */ '../views/PayOfAnother.vue')
    }
]
